import React from 'react';
import { translate, Interpolate, InjectedTranslateProps } from 'react-i18next';
import styles from './NoMembersFound.scss';

interface NoMembersFoundProps extends InjectedTranslateProps {
  searchTerm: string;
}

export const NoMembersFound = translate()(
  class extends React.Component<NoMembersFoundProps> {
    render() {
      const { t, searchTerm } = this.props;

      return (
        <div className={styles.emptyState}>
          <div
            data-hook="no-members-found.primary"
            className={styles.primaryText}
          >
            <Interpolate
              i18nKey="social.new-chat.no-members.primary-message"
              searchTerm={searchTerm}
            />
          </div>
          <div
            data-hook="no-members-found.secondary"
            className={styles.secondaryText}
          >
            {t('social.new-chat.no-members.secondary-message')}
          </div>
        </div>
      );
    }
  },
);
